__turbopack_context__.v({
  "banner": "styles-module-scss-module__jKqULq__banner",
  "item": "styles-module-scss-module__jKqULq__item",
  "marquee": "styles-module-scss-module__jKqULq__marquee",
  "marqueeX": "styles-module-scss-module__jKqULq__marqueeX",
  "root": "styles-module-scss-module__jKqULq__root",
  "tilt": "styles-module-scss-module__jKqULq__tilt",
  "track": "styles-module-scss-module__jKqULq__track",
});
